import './bootstrap.js'
import 'sweetalert2'
import '../css/swal.scss';

import { createApp } from 'vue'

import Exchange from "./Sections/Exchange.vue"
import Market from "./Sections/Market.vue"
import HomePage from "./Sections/HomePage.vue"
import OrdersDedicated from "./Sections/OrdersDedicated.vue";
import Withdraw from "./Sections/Withdraw.vue";
import Account from "./Sections/Account.vue";

import { backendSocket } from "./sockets"
import { library } from "@fortawesome/fontawesome-svg-core";
import { faMagnifyingGlass } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

library.add(faMagnifyingGlass);

if (document.getElementById('exchange')) createApp(Exchange).component("font-awesome-icon", FontAwesomeIcon).mount("#exchange")
if (document.getElementById('market')) createApp(Market).mount("#market")
if (document.getElementById('homepage')) createApp(HomePage).mount("#homepage")
if (document.getElementById('ordersDedicated')) createApp(OrdersDedicated).component("font-awesome-icon", FontAwesomeIcon).mount("#ordersDedicated")
if (document.getElementById('withdraw')) createApp(Withdraw).component("font-awesome-icon", FontAwesomeIcon).mount("#withdraw")
if (document.getElementById('account')) createApp(Account).component("font-awesome-icon", FontAwesomeIcon).mount("#account")

const userId = $('meta[name="user-id"]').attr('content');

if (userId !== '') {
    backendSocket.private(`private.user.${userId}`).listen('.notification', ({userId, title, type, position, timer}) => {
        const Toast = Swal.mixin({
            toast: true,
            position: position,
            showConfirmButton: false,
            timer: timer,
            timerProgressBar: true,
            didOpen: (toast) => {
                toast.addEventListener('mouseenter', Swal.stopTimer)
                toast.addEventListener('mouseleave', Swal.resumeTimer)
            }
        })

        Toast.fire({
            icon: type,
            title: title
        })
    })
}
